import React from 'react'

function FScreen(props) {
  return (
    <div className="screen">
      {props.children}
    </div>
  )
}

export default FScreen
